var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logoblack-de30acc4cc3e64f1936340bafd1bdb85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 201.4,
    height: 47.4,
    viewBox: "0 0 201.4 47.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 201.4,
    height: 47.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_black",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    d: "M23.7,0A23.7,23.7,0,1,1,0,23.7H0A23.686,23.686,0,0,1,23.7,0Z",
    fill: "#27323d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    d: "M26.7,9.3,37.8,20.4l-11.1,12",
    fill: "none",
    stroke: "#8fd4e6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    d: "M26.6,9.6,20.9,38.4",
    fill: "none",
    stroke: "#8fd4e6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    d: "M20.7,15.5,9.6,27.3,20.7,38.4",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M76,26.1a6.529,6.529,0,0,1-.5,2,6.447,6.447,0,0,1-1.1,1.6,6.149,6.149,0,0,1-1.8,1.1,6.051,6.051,0,0,1-2.4.4,6.963,6.963,0,0,1-2.5-.5,5.223,5.223,0,0,1-1.9-1.4,7.761,7.761,0,0,1-1.2-2.2,8.85,8.85,0,0,1-.4-2.9V23a8.85,8.85,0,0,1,.4-2.9,6.6,6.6,0,0,1,1.2-2.2,5.223,5.223,0,0,1,1.9-1.4,6.963,6.963,0,0,1,2.5-.5,6.051,6.051,0,0,1,2.4.4,4.181,4.181,0,0,1,1.7,1.1,5.715,5.715,0,0,1,1.1,1.6,6.477,6.477,0,0,1,.5,2.1H73.3a4.961,4.961,0,0,0-.3-1.3,2.075,2.075,0,0,0-.6-1,1.8,1.8,0,0,0-.9-.6c-.2-.3-.7-.3-1.2-.3a3.339,3.339,0,0,0-1.5.3,2.591,2.591,0,0,0-1.1,1,4.79,4.79,0,0,0-.7,1.6,12.482,12.482,0,0,0-.2,2.1v1.2a12.31,12.31,0,0,0,.2,2,4.418,4.418,0,0,0,.6,1.6,2.66,2.66,0,0,0,1.1,1,3.313,3.313,0,0,0,1.5.4,5.212,5.212,0,0,0,1.4-.2,2.075,2.075,0,0,0,1-.6,4.7,4.7,0,0,0,.6-.9c.1-.4.2-.8.3-1.3H76Z",
    fill: "#27323d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M91.5,23.9a10.124,10.124,0,0,1-.4,3.1,5.762,5.762,0,0,1-1.3,2.3,5.223,5.223,0,0,1-1.9,1.4,6.963,6.963,0,0,1-2.5.5,6.551,6.551,0,0,1-2.5-.5,5.579,5.579,0,0,1-2-1.4A5.763,5.763,0,0,1,79.6,27a9.587,9.587,0,0,1-.5-3.1v-.8a10.069,10.069,0,0,1,.5-3.1,5.762,5.762,0,0,1,1.3-2.3,4.831,4.831,0,0,1,2-1.4,6.963,6.963,0,0,1,2.5-.5,6.551,6.551,0,0,1,2.5.5,5.579,5.579,0,0,1,2,1.4A7.277,7.277,0,0,1,91.2,20a9.721,9.721,0,0,1,.4,3.1v.8Zm-2.6-.8a13.786,13.786,0,0,0-.2-2.2,5.929,5.929,0,0,0-.7-1.6,3.459,3.459,0,0,0-1.1-1,3.653,3.653,0,0,0-1.5-.3,3.339,3.339,0,0,0-1.5.3,2.591,2.591,0,0,0-1.1,1,3.9,3.9,0,0,0-.7,1.6,7.316,7.316,0,0,0-.3,2.2v.8a7.316,7.316,0,0,0,.3,2.2,5.929,5.929,0,0,0,.7,1.6,3.46,3.46,0,0,0,1.1,1,3.339,3.339,0,0,0,1.5.3,3.225,3.225,0,0,0,2.7-1.3,6.135,6.135,0,0,0,.9-3.8v-.8Z",
    fill: "#27323d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M95.3,31V16.1h4.4a7.635,7.635,0,0,1,2.7.5,5.957,5.957,0,0,1,2.1,1.4,6.356,6.356,0,0,1,1.4,2.2,8.807,8.807,0,0,1,.5,2.9v.7a8.361,8.361,0,0,1-.5,2.9,6.01,6.01,0,0,1-3.6,3.6,8.21,8.21,0,0,1-2.8.5H95.3Zm2.6-12.8V29h1.7a5.822,5.822,0,0,0,1.9-.3,3.249,3.249,0,0,0,1.3-1,4.02,4.02,0,0,0,.8-1.6,6.648,6.648,0,0,0,.3-2.1v-.8a5.63,5.63,0,0,0-1.1-3.7,3.615,3.615,0,0,0-3.1-1.3Z",
    fill: "#27323d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M119.1,24.3H113v4.6h7.2V31h-9.8V16.1h9.7v2.1H113v4.1h6.1v2Z",
    fill: "#27323d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M133.8,25.7V31h-3.1V16.1h5.8a6.051,6.051,0,0,1,2.4.4,5.244,5.244,0,0,1,1.8,1,4.569,4.569,0,0,1,1.1,1.6,4.477,4.477,0,0,1,.4,2,4.477,4.477,0,0,1-.4,2,4.177,4.177,0,0,1-1.1,1.5,5.076,5.076,0,0,1-1.8.9,8.751,8.751,0,0,1-2.4.3h-2.7Zm0-2.5h2.7a3.6,3.6,0,0,0,1.1-.2,2.177,2.177,0,0,0,.8-.5,1.012,1.012,0,0,0,.4-.7c0-.3.1-.6.1-.9a2.768,2.768,0,0,0-.1-.9,2.01,2.01,0,0,0-.4-.8,2.177,2.177,0,0,0-.8-.5,3.6,3.6,0,0,0-1.1-.2h-2.7Z",
    fill: "#8fd4e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M152.1,27.9h-5.4l-1,3.1h-3.3L148,16.1h2.9L156.5,31h-3.3Zm-4.5-2.5h3.7l-1.9-5.6Z",
    fill: "#8fd4e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M164.6,25.5h-2.5V31H159V16.1h5.5a8.017,8.017,0,0,1,2.3.3,3.932,3.932,0,0,1,1.7.9,3.815,3.815,0,0,1,1.1,1.4,4.058,4.058,0,0,1,.4,1.9,7.72,7.72,0,0,1-.2,1.5,6.118,6.118,0,0,1-.5,1.2,6.469,6.469,0,0,1-.8.9,4.129,4.129,0,0,1-1.1.7l3.2,6.1h-3.3ZM162.2,23h2.5a3.6,3.6,0,0,0,1.1-.2,2.177,2.177,0,0,0,.8-.5,1.794,1.794,0,0,0,.5-.7,2.92,2.92,0,0,0,.2-.9,2.352,2.352,0,0,0-.6-1.7,2.445,2.445,0,0,0-1.8-.6h-2.5V23Z",
    fill: "#8fd4e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M179.1,27.3l3.4-11.2h3.4L180.7,31h-3.2l-5.2-14.9h3.4Z",
    fill: "#8fd4e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M196.2,27.9h-5.4l-1,3.1h-3.3l5.6-14.9H195L200.6,31h-3.3Zm-4.6-2.5h3.7l-1.9-5.6Z",
    fill: "#8fd4e6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.4523f3a76b54d503069ef764fb96f2c4.svg";
export { ForwardRef as ReactComponent };